import React from "react";
import { useState, useEffect } from 'react';
import '../HomePage/Quotes.css';
import loader from '../Images/SmcLoader.png';
import { CopyToClipboard } from 'react-copy-to-clipboard';


const EnquiryDetail = ({ plansCount, EnquiryNo, policyTerm, setPolicyTerm, }) => {
    const [isLoader, setIsLoader] = useState(true);
    const [copyText, setCopyText] = useState(false);

    const handleCopy = () => {
        setCopyText(true)
        setTimeout(() => setCopyText(false), 2000);
        //alert("copied!")
    }

    useEffect(() => {
        setIsLoader(plansCount > 0 ? false : true);
    }, [plansCount]);

    useEffect(() => {
        const timer = setTimeout(() => {
            setIsLoader(false);
        }, 15000);

        return () => clearTimeout(timer);
    }, [plansCount])

    return (
        <>
            <div className="Enquiry_Detail">
                <div className="row">
                    <div className="Enquiry">
                        <div className="col-md-4">
                            <div>
                                {/*<h4 className="mb-0">{plansCount??0 } Plan Found</h4>*/}
                                <h4 className="mb-0">{isLoader ? <img className="load" src={loader} /> : (plansCount == 1 || plansCount == 0)  ? `${plansCount} Plan Found` : `${plansCount} Plans Found`}</h4>
                                <small>Prices Exclusive of GST</small>
                            </div>
                        </div>
                        <div className="col-md-8 text-end">
                            <div className="EnqDetail_box">
                                <div className="Enq_space">
                                    <div className="ENQ_box">
                                        {/*<p className="LeadID" onClick="" ><span id="textCopeid">{props.enq}</span><span><i className="fa fa-clone mx-2"></i></span></p>*/}
                                        <CopyToClipboard text={EnquiryNo}
                                            onCopy={handleCopy} >
                                            <p className="LeadID" >Lead ID: <span id="textCopeid" >{EnquiryNo} &nbsp;<i className="fa fa-clone"></i></span></p>
                                        </CopyToClipboard>
                                    </div>
                                    {copyText && <div className="Enq_popup">Copied!</div>}
                                    <button className="shareButton" data-target="#shareModel" data-toggle="modal" value="Share Quotes">
                                        <i className="fa fa-whatsapp"></i>
                                        <span className="SQText">&nbsp;Share Quotes</span>
                                    </button>
                                </div>
                                {/*<div className="policy_term2">
                                    <span className="d-block mt-2">Policy Term</span>
                                    <select value={policyTerm} onChange={setPolicyTerm}>
                                        <option value="1">1 year</option>
                                        <option value="2">2 years</option>
                                        <option value="3">3 years</option>
                                        <option value="4">4 years</option>
                                        <option value="5">5 years</option>
                                        <option value="6">6 years</option>
                                        <option value="7">7 years</option>
                                        <option value="8">8 years</option>
                                        <option value="9">9 years</option>
                                        <option value="10">10 years</option>
                                    </select>
                                </div>*/}
                            </div>
                            {/*<p>
                                <span>Lead ID:
                                    <strong className="ng-binding">
                                        <span>{EnquiryNo }&nbsp;<i className="fa fa-copy"></i>
                                        </span>
                                    </strong>
                                </span>
                            </p>*/}
                        </div>
                    </div>
                </div>
            </div>
           
        </>
    );
}
export default EnquiryDetail;